import { Route } from "react-router-dom";

import { PURCHASE_ORDERS_ROUTES } from "src/pages/purchaseOrders/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { CreatePurchaseOrder } from "./CreatePurchaseOrder";
import { PurchaseOrders } from "./PurchaseOrders.page";

/** Route tree for the purchase orders module, mounted under `/purchase-orders`. */
export const purchaseOrdersRoutes = (
  <>
    <Route path={PURCHASE_ORDERS_ROUTES.root} element={<ProtectedRoute component={PurchaseOrders} />} />
    <Route path={PURCHASE_ORDERS_ROUTES.create} element={<ProtectedRoute component={CreatePurchaseOrder} />} />
  </>
);
